import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import Card from "../../components/Card";
import ContentList from "../../components/ContentList";
import Loader from "../../components/Loader";
import { setInterface } from "../../redux/slices/interfaceSlice";
import service from "../../service";
import swal from "@sweetalert/with-react";
import BigLoader from "../../components/BigLoader";
import ReactPaginate from "react-paginate";
import { Fragment } from "react";

export default function Content() {
  const [loading, setLoading] = useState(true);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [total, setTotal] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const getData = () => {
    setLoading(true);
    service
      .get("/api/content", { params: { page } })
      .then((response) => {
        const { total, data } = response.data;
        setTotal(total);
        setData(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const onDelete = (id) => {
    swal({
      title: "Anda yakin?",
      text: "Anda akan menghapus konten ini",
      icon: "warning",
      buttons: ["Batal", true],
      dangerMode: true,
      cancelButton: "Batal",
    }).then((value) => {
      if (value) {
        setLoadingDelete(true);
        service.delete(`/api/content/${id}`).then(() => {
          swal("Berhasil", "Konten telah dihapus", "success");
          getData();
        });
      }
    });
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Ring",
        pageTitle: "Ring",
        rightButton: {
          to: "/content/add",
          label: "Tambah",
          color: "green",
          withPlusIcon: true,
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <Card>
      <Helmet>
        <title>Ring</title>
      </Helmet>
      {loading ? (
        <div className="h-64 flex justify-center items-center flex-col">
          <Loader className="bg-black-100" />
          <span className="mt-3 text-black-300 text-sm">Memuat</span>
        </div>
      ) : data.length ? (
        <Fragment>
          {data.map((item, index) => (
            <ContentList
              imgSrc={item.cover}
              title={item.title}
              babs={item.babs_count}
              key={`${index}`}
              createdTime={item.created_at}
              id={item.id}
              onDelete={onDelete}
            />
          ))}

          <ReactPaginate
            pageCount={total}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            initialPage={page - 1}
            containerClassName="flex flex-wrap mt-6 gap-1"
            previousLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            nextLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            pageLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            activeLinkClassName="bg-primary-500 border-primary-600 text-white-100"
            onPageChange={({ selected }) => setPage(selected + 1)}
          />
        </Fragment>
      ) : (
        <div className="text-center flex flex-col justify-center items-center h-40 text-black-300">
          <p>Belum ada konten</p>
        </div>
      )}
      {loadingDelete && <BigLoader />}
    </Card>
  );
}
